import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

/** KPI locations and plants the user may open, as the legacy HProduce app checks them */
export type KpiDashboardAccess = {
  /** e.g. `singlePlantAccess`, `singleCountryAccess`, `multiLocationsAccess` */
  status: string
  accessiblePlantIds?: string[]
  /** KPI location ids (areas, regions, countries) */
  accessibleLocations?: string[]
}

export const useKpiDashboardAccess = () =>
  useQuery<KpiDashboardAccess, AxiosError>({
    queryKey: ['kpi-dashboard-accessibility'],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<KpiDashboardAccess>(
        '/kpi/dashboard/accessibility',
        {signal}
      )
      return response.data
    }
  })
